import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "content"]

  open(event) {
    event.preventDefault()
    const modalContent = event.currentTarget.dataset.modalContent
    this.contentTarget.innerHTML = modalContent
    this.containerTarget.classList.remove("hidden")
  }

  close() {
    this.containerTarget.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    if (!this.contentTarget.contains(event.target)) {
      this.close()
    }
  }
}